import { Box, TextField } from '@mui/material'
import React from 'react'
import { useState, useEffect } from 'react'

const RangeInput = ({ input, handleInputChange, startLabel, endLabel, placeholder }) => {
    const [leftInput, setLeftInput] = useState("")
    const [rightInput, setRightInput] = useState("");

    useEffect(() => {
        if (leftInput || rightInput) {
            handleInputChange(leftInput + ',' + rightInput);
        }
    }, [leftInput, rightInput])

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1
        }}>
            <TextField
                value={leftInput}
                size='small'
                label={startLabel || ''}
                placeholder={placeholder || ''}
                onChange={(e) => setLeftInput(e.target.value)} />
            <TextField
                value={rightInput}
                size='small'
                label={endLabel || ''}
                placeholder={placeholder || ''}
                onChange={(e) => setRightInput(e.target.value)} />
        </Box>
    )
}

export default RangeInput